/**
 * Enum for Module IDs
 * @readonly
 * @enum {name: {value: number}}
 */

// Employee Page Access Module IDs
export const SpaEpaModuleIdEnum = Object.freeze({
  basicInformation: 1,
  workInformation: 2,
  governmentInformation: 3,
  educationInformation: 4,
  contactInformation: 5,
  visa: 6,
  dependent: 7,
  benefits: 8,
  leave: 9,
  salary: 10,
  advances: 11,
  training: 12,
  assets: 13,
  memo: 14,
  seminars: 15,
  employmentRecord: 16,
  movement: 17,
  documents: 18,
  requirements: 19,
  accessLevel: 20,
  medicalRecords: 21,
  performanceManagement: 22,
  workScheduleInformation: 23,
  uploadPictures: 24,
  currentPayrollInfo: 25,
  location: 26,
});

// Navigation Access Module IDs
export const NaModuleIdEnum = Object.freeze({
  employeeProfile: 1,
  employeeSearch: 2,
  companyMaintenance: 3,
  calendar: 4,
  leaveApplication: 5,
  overtimeApplication: 6,
  undertimeApplication: 7,
  loanApplication: 8,
  obApplication: 9,
  taskNavAccess: 10,
  leaveSearch: 11,
  overtimeSearch: 12,
  undertimeSearch: 13,
  loanSearch: 14,
  obSearch: 15,
  coeGenerator: 16,
  employeeReport: 17,
  employeeManage: 18,
  employeeReqTemplate: 19,
  reports: 20,
  attendanceManagement: 21,
  leaveManagement: 22,
  maintenance: 23,
  emailBlast: 24,
  emailTemplates: 25,
  employeeGroup: 26,
  coaApplication: 27,
  schedAdjustApplication: 28,
  otReports: 29,
  coaSearch: 30,
  memoSearch: 31,
  attendanceReport: 32,
  auditTrail: 33,
  schedAdjustSearch: 34,
  uploadPicture: 35,
  workPlaceMaintenance: 36,
  assetsMaintenance: 37,
  visaMaintenance: 38,
  benefitsMaintenance: 39,
  holidaysMaintenance: 40,
  biometricsMaintenance: 41,
  accessLevelMaintenance: 42,
  formTemplateMaintenance: 43,
  saBulkUpload: 44,
  otBulkUpload: 45,
  employeeBulkUpload: 46,
  biologsBulkUpload: 47,
  attendanceManagementAddBiolog: 48,
  attendanceManagementUploadBiolog: 49,
  teamCalendar: 50,
  teamAttendance: 51,
  manageSchedule: 52,
  employeeDirectory: 53,
  timesheetLock: 54,
  temperatureMonitoring: 55,
  editTemperature: 56,
  announcementModule: 57,
  notificationModule: 58,
  projectTaggingMaintenance: 59,
  projectTaggingApplication: 60,
  jobRequestModule: 61,
  bulkUtilityModule: 62,
  breakMonitoringReport: 63,
  employeeHub: 64,
  profileTemplateSettings: 65,
  employeeHubFieldsForBulkActionUtility: 66,
  ecosystemDashboardFlowRequests: 67,
  employeeHubEditNewFields: 68,
  attendanceLogs: 200,
  featureManagement: 69,
  shiftCenter: 1001,
  globalProfileAttributes: 1002,
  location: 26,
});
